import { createAction } from 'typesafe-actions';
import { TRACK_EVENT } from './action-types.js';

export type TrackEventPayload = { eventName: string; data: Record<string, any> } | string;
export const trackEvent = createAction(TRACK_EVENT)<TrackEventPayload>();
export type TrackEvent = typeof trackEvent;
